export default __webpack_public_path__ + "static/media/download-pdf.5da4d9c7.png";